<template>
  <div class="certificate">
    <img src="./img/certificate2.jpeg" alt="" />
    <img src="./img/certificate3.jpg" alt="" />
  </div>
</template>

<script>
export default {
  name: "about",

  data() {
    return {};
  },

  beforeDestroy() {},
  created() {},

  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.certificate {
  margin-top: 0.7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 50%;
  }
}
</style>
